/* eslint-disable react-refresh/only-export-components */
import type { ReactNode } from "react";
import { createSearchMatcher } from "../../../../utils/search";

// Общото на картите на масите (`TableCard` — телефон/таблет, `DesktopTableCard`
// — десктоп): оцветяването на търсеното.

// Маркира срещанията на `term` в `text` с топъл акцентен фон. Диапазоните идват
// от общия matcher (`utils/search.ts`) — същият, с който филтрираме — затова се
// оцветява и съвпадение на „шльокавица" („iv" в „Иван").
export function highlightParts(text: string, term: string): ReactNode {
  const matcher = createSearchMatcher(term);
  const ranges = matcher.isEmpty ? [] : matcher.ranges(text);
  if (ranges.length === 0) return text;

  const parts: ReactNode[] = [];
  let cursor = 0;
  ranges.forEach((range, index) => {
    if (range.start > cursor) parts.push(text.slice(cursor, range.start));
    parts.push(
      <span
        key={index}
        className="bg-pos-disc-bg text-pos-disc-ink font-extrabold"
      >
        {text.slice(range.start, range.end)}
      </span>,
    );
    cursor = range.end;
  });
  if (cursor < text.length) parts.push(text.slice(cursor));
  return parts;
}

export function Highlight({
  text,
  term,
  className,
}: {
  text: string;
  term: string;
  className?: string;
}) {
  // inline-block е критичен — иначе max-width/overflow/ellipsis не работят
  // и текстът прелива извън картата на тесни екрани (телефон/таблет).
  const cls = `inline-block ${className ?? ""}`;
  return <span className={cls}>{highlightParts(text, term)}</span>;
}
